import { React, Component } from "react";
import { Typography, Grid, Box, Divider } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TwitterIcon from "@mui/icons-material/Twitter";
class footer extends Component {
  render() {
    return (
      <>
        {/* Footer */}
        <Box
          sx={{
            minHeight: "350px",
            backgroundColor: "#232F3E",
            color: "white",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, md: 5 },
          }}>
          {/* Left Section */}
          <Box
            sx={{
              maxWidth: { xs: "100%", md: "300px" },
              textAlign: { xs: "center", md: "left" },
            }}>
            <a href="https://www.jnine.in/"  target ="blank"  style={{ textDecoration: "none",color:"white"  }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "serif",
                  fontSize: { xs: "28px", md: "35px" },
                }}>
                Jnine Infotech
              </Typography>
            </a>
            <Typography sx={{ wordSpacing: "5px", maxWidth: "300px", mt: 2 }}>
              Create codes with our free QR generator of codes. Comprehensible
              interface, variety in choosing the type of your QR-code, the
              ability to view statistics!
            </Typography>
          </Box>

          {/* Divider for larger screens */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              display: { xs: "none", md: "block" },
              backgroundColor: "white",
              height: "350px",
            }}
          />

          {/* Links Section */}
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{ maxWidth: "100%", mt: { xs: 2, md: 0 } }}>
            <Grid
              item
              xs={12}
              md={3}
              alignItems="center"
              justifyContent="center">
              <Typography variant="h6" textAlign="center">
                Product
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  alignItems: "center",
                  marginTop: "10px",
                  justifyContent: "center",
                }}>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Benefit
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Where to Use?
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  API
                </a>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" textAlign="center">
                Information
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  marginTop: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <a
                  href="#"
                  style={{
                    textDecoration: "none",
                    color: "whitesmoke",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  Payment & Content
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Pricing
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  GDPR
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Trust Pilot
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Reviews
                </a>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" textAlign="center">
                Legal
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  marginTop: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  About Us
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Account & Payment
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Privacy & Policy
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Terms & Conditions
                </a>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" textAlign="center">
                Support
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  FAQs
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Instructions
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Blog
                </a>
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "whitesmoke" }}>
                  Help Center
                </a>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" textAlign="center">
                Contact Us:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                  cursor: "pointer",
                }}>
                <FacebookIcon />
                <InstagramIcon />
                <WhatsAppIcon />
                <TwitterIcon />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Bottom Bar */}
        <Box
          sx={{
            minHeight: "60px",
            backgroundColor: "#131921",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}>
          <Typography variant="body2">
            © 2024 CopyRight: Jnine Infotech
          </Typography>
        </Box>
      </>
    );
  }
}

export default footer;
